// AUTO-GENERATED by scripts/sync-rbac.mjs from rbac-config.json — do not edit by hand.

export const PAGES = {
    ORG: "/admin-settings/access-mgmt/org",
    ORG_USER: "/admin-settings/access-mgmt/org-user",
    GAME_ACCESS_MGMT: "/admin-settings/game-mgmt/game-access-mgmt",
    GAMES: "/admin-settings/game-mgmt/games",
    PAGE_MGMT: "/admin-settings/role-access-mgmt/page",
    ROLE_MGMT: "/admin-settings/role-access-mgmt/role",
    USER_MGMT: "/admin-settings/user-mgmt",
    AI_CREDITS: "/ai-credits",
    CHEATS_ABTEST_AGGREGATION: "/cheats/abtest-aggregation",
    CHEATS_BIGQUERY_SP_DEPLOYMENT: "/cheats/bigquery-sp-deployment",
    CHEATS_BOOTSTRAP: "/cheats/bootstrap",
    CHEATS_CACHE_MANAGEMENT: "/cheats/cache-management",
    CHEATS_DASHBOARD: "/cheats/dashboard",
    CHEATS_DASHBOARD_CATALOG: "/cheats/dashboard-catalog",
    CHEATS_DASHBOARD_MIGRATION: "/cheats/dashboard-migration",
    CHEATS_DATA_CONNECTION_TOOLS: "/cheats/data-connection-tools",
    CHEATS_DATA_MIGRATION: "/cheats/data-migration",
    CHEATS_DEPENDENCY_GRAPH: "/cheats/dependency-graph",
    CHEATS_GAME_INVITATIONS: "/cheats/game-invitations",
    CHEATS_GAME_MANAGEMENT: "/cheats/game-management",
    CHEATS_IMPERSONATION: "/cheats/impersonation",
    CHEATS_INDEX_INITIALIZATION: "/cheats/index-initialization",
    CHEATS_INVITATIONS: "/cheats/invitations",
    CHEATS_METRIC_CATALOG: "/cheats/metric-catalog",
    CHEATS_METRIC_INSTANCES: "/cheats/metric-instances",
    CHEATS_MIRROR_BACKFILL: "/cheats/mirror-backfill",
    CHEATS_NOTIFICATIONS: "/cheats/notifications",
    CHEATS_ORG_MANAGEMENT: "/cheats/org-management",
    CHEATS_PARAM_MANAGEMENT: "/cheats/param-management",
    CHEATS_PLAYER_ATTRIBUTE_RESET: "/cheats/player-attribute-reset",
    CHEATS_RBAC_MANAGEMENT: "/cheats/rbac-management",
    CHEATS_REDIS_MANAGEMENT: "/cheats/redis-management",
    CHEATS_SOURCE_CODE: "/cheats/source-code",
    CHEATS_SYSTEM_PROMPTS: "/cheats/system-prompts",
    CHEATS_TOOL_REGISTRY: "/cheats/tool-registry",
    CHEATS_USER_MANAGEMENT: "/cheats/user-management",
    CHEATS_WIDGET_MIGRATION: "/cheats/widget-migration",
    GAME_DECISION_CENTER: "/game/ai-recommendations",
    AI_ALERTS: "/game/ai-studio/alerts",
    QUERY_LIBRARY: "/game/ai-studio/query-library",
    SKILL_REGISTRY: "/game/ai-studio/skill-registry",
    AI_WORKFLOW: "/game/ai-studio/workflow",
    CONTENT_CALENDAR: "/game/calendar",
    CHAT: "/game/chat",
    GAME_CONFIG: "/game/configs",
    GAME_DASHBOARD: "/game/dashboard",
    EVENT_GROUPS: "/game/data-intelligence/event-groups",
    EVENTS: "/game/data-intelligence/events",
    GAME_CLIENT_METRIC_CATALOG: "/game/data-intelligence/metric-catalog",
    GAME_CLIENT_PARAMS: "/game/data-intelligence/params",
    LIVE_EVENTS: "/game/live-events",
    EXPERIMENTS: "/game/live-services/experiments",
    FLYWHEELS: "/game/live-services/flywheels",
    UPCOMING_EVENTS: "/game/live-services/upcoming",
    PLAYER_ATTRIBUTES: "/game/player-attributes",
    SEGMENTATION: "/game/segments",
    DATA_CONNECTIONS: "/game/settings/data",
    GAME_SETUP: "/game/settings/details",
    GAME_HISTORY: "/game/settings/history",
    GAME_KNOWLEDGE: "/game/settings/knowledge",
    VECTOR_INDEX: "/game/settings/knowledge/vector-index",
    OBJECTIVES: "/game/settings/objectives",
    SDK_INTEGRATION: "/game/settings/sdk",
    GAME_FEATURES: "/game/settings/systems",
    CLIENT_VERSIONS: "/game/settings/versions",
    PORTFOLIO: "/portfolio",
};

export const COMPONENTS = {
    ORG_CREATE_ORGANIZATION: "/admin-settings/access-mgmt/org.create-organization",
    ORG_MUTATE_ORGANIZATION: "/admin-settings/access-mgmt/org.mutate-organization",
    ORG_VIEW_ORGANIZATIONS_LIST: "/admin-settings/access-mgmt/org.view-organizations-list",
    GAME_ACCESS_MGMT_MUTATE_GAME_USER: "/admin-settings/game-mgmt/game-access-mgmt.mutate-game-user",
    GAMES_ACTIVATE_GAME: "/admin-settings/game-mgmt/games.activate-game",
    GAMES_CREATE_GAME: "/admin-settings/game-mgmt/games.create-game",
    GAMES_MUTATE_GAME: "/admin-settings/game-mgmt/games.mutate-game",
    GAMES_SUSPEND_GAME: "/admin-settings/game-mgmt/games.suspend-game",
    GAMES_VIEW_GAMES_LIST: "/admin-settings/game-mgmt/games.view-games-list",
    PAGE_MGMT_DESTRUCTIVE_PAGE_REGISTRY: "/admin-settings/role-access-mgmt/page.destructive-page-registry",
    PAGE_MGMT_MUTATE_PAGE_REGISTRY: "/admin-settings/role-access-mgmt/page.mutate-page-registry",
    PAGE_MGMT_VIEW_PAGES_LIST: "/admin-settings/role-access-mgmt/page.view-pages-list",
    ROLE_MGMT_ASSIGN_PAGE_PERMISSIONS: "/admin-settings/role-access-mgmt/role.assign-page-permissions",
    ROLE_MGMT_CREATE_ROLE: "/admin-settings/role-access-mgmt/role.create-role",
    ROLE_MGMT_DESTRUCTIVE_ROLE: "/admin-settings/role-access-mgmt/role.destructive-role",
    ROLE_MGMT_MUTATE_ROLE: "/admin-settings/role-access-mgmt/role.mutate-role",
    ROLE_MGMT_MUTATE_SYSTEM_ROLE: "/admin-settings/role-access-mgmt/role.mutate-system-role",
    ROLE_MGMT_VIEW_ROLES_LIST: "/admin-settings/role-access-mgmt/role.view-roles-list",
    USER_MGMT_INVITE_USER: "/admin-settings/user-mgmt.invite-user",
    USER_MGMT_MUTATE_USER_ACCESS: "/admin-settings/user-mgmt.mutate-user-access",
    USER_MGMT_REVOKE_USER_ACCESS: "/admin-settings/user-mgmt.revoke-user-access",
    USER_MGMT_VIEW_USERS_LIST: "/admin-settings/user-mgmt.view-users-list",
    AI_CREDITS_GRANT_CREDITS: "/ai-credits.grant-credits",
    AI_CREDITS_PURCHASE_CREDITS: "/ai-credits.purchase-credits",
    AI_CREDITS_SET_ALLOCATION_MODE: "/ai-credits.set-allocation-mode",
    AI_CREDITS_SET_USER_LIMIT: "/ai-credits.set-user-limit",
    AI_CREDITS_VIEW_ALL_USAGE: "/ai-credits.view-all-usage",
    AI_CREDITS_VIEW_USAGE: "/ai-credits.view-usage",
    CHEATS_SYSTEM_PROMPTS_CREATE_SYSTEM_PROMPT: "/cheats/system-prompts.create-system-prompt",
    CHEATS_SYSTEM_PROMPTS_DELETE_SYSTEM_PROMPT: "/cheats/system-prompts.delete-system-prompt",
    CHEATS_SYSTEM_PROMPTS_IMPORT_SYSTEM_PROMPTS: "/cheats/system-prompts.import-system-prompts",
    CHEATS_SYSTEM_PROMPTS_MUTATE_SYSTEM_PROMPT: "/cheats/system-prompts.mutate-system-prompt",
    CHEATS_SYSTEM_PROMPTS_VIEW_SYSTEM_PROMPTS_LIST: "/cheats/system-prompts.view-system-prompts-list",
    GAME_DECISION_CENTER_EDIT_PORTFOLIO_LAYOUT: "/game/ai-recommendations.edit-portfolio-layout",
    GAME_DECISION_CENTER_VIEW_GAMES_PORTFOLIO: "/game/ai-recommendations.view-games-portfolio",
    AI_ALERTS_DESTRUCTIVE_ALERT: "/game/ai-studio/alerts.destructive-alert",
    AI_ALERTS_MUTATE_ALERT: "/game/ai-studio/alerts.mutate-alert",
    AI_ALERTS_VIEW_ALERTS: "/game/ai-studio/alerts.view-alerts",
    QUERY_LIBRARY_CREATE_QUESTION: "/game/ai-studio/query-library.create-question",
    QUERY_LIBRARY_MUTATE_QUESTION: "/game/ai-studio/query-library.mutate-question",
    QUERY_LIBRARY_VIEW_QUESTIONS_LIST: "/game/ai-studio/query-library.view-questions-list",
    SKILL_REGISTRY_CREATE_SKILL: "/game/ai-studio/skill-registry.create-skill",
    SKILL_REGISTRY_MUTATE_SKILL: "/game/ai-studio/skill-registry.mutate-skill",
    SKILL_REGISTRY_VIEW_SKILLS_LIST: "/game/ai-studio/skill-registry.view-skills-list",
    AI_WORKFLOW_CREATE_WORKFLOW: "/game/ai-studio/workflow.create-workflow",
    AI_WORKFLOW_MUTATE_WORKFLOW: "/game/ai-studio/workflow.mutate-workflow",
    AI_WORKFLOW_RUN_WORKFLOW: "/game/ai-studio/workflow.run-workflow",
    AI_WORKFLOW_VIEW_WORKFLOWS_LIST: "/game/ai-studio/workflow.view-workflows-list",
    CONTENT_CALENDAR_VIEW_CALENDAR: "/game/calendar.view-calendar",
    GAME_CONFIG_CREATE_GAME_CONFIG: "/game/configs.create-game-config",
    GAME_CONFIG_DESTRUCTIVE_GAME_CONFIG: "/game/configs.destructive-game-config",
    GAME_CONFIG_MUTATE_GAME_CONFIG: "/game/configs.mutate-game-config",
    GAME_DASHBOARD_DESTRUCTIVE_QUERY: "/game/dashboard.destructive-query",
    GAME_DASHBOARD_RUN_QUERY: "/game/dashboard.run-query",
    GAME_DASHBOARD_SAVE_QUERY: "/game/dashboard.save-query",
    GAME_DASHBOARD_VIEW_SAVED_QUERIES: "/game/dashboard.view-saved-queries",
    EVENT_GROUPS_CREATE_EVENT_GROUP: "/game/data-intelligence/event-groups.create-event-group",
    EVENT_GROUPS_MUTATE_EVENT_GROUP: "/game/data-intelligence/event-groups.mutate-event-group",
    EVENT_GROUPS_VIEW_EVENT_GROUPS_LIST: "/game/data-intelligence/event-groups.view-event-groups-list",
    EVENTS_CREATE_EVENT_REGISTRY: "/game/data-intelligence/events.create-event-registry",
    EVENTS_MUTATE_EVENT_REGISTRY: "/game/data-intelligence/events.mutate-event-registry",
    EVENTS_VIEW_EVENT_REGISTRIES_LIST: "/game/data-intelligence/events.view-event-registries-list",
    GAME_CLIENT_METRIC_CATALOG_CREATE_METRIC_CATALOG: "/game/data-intelligence/metric-catalog.create-metric-catalog",
    GAME_CLIENT_METRIC_CATALOG_MUTATE_METRIC_CATALOG: "/game/data-intelligence/metric-catalog.mutate-metric-catalog",
    GAME_CLIENT_METRIC_CATALOG_VIEW_METRIC_CATALOGS_LIST: "/game/data-intelligence/metric-catalog.view-metric-catalogs-list",
    GAME_CLIENT_PARAMS_CREATE_PARAM: "/game/data-intelligence/params.create-param",
    GAME_CLIENT_PARAMS_MUTATE_PARAM: "/game/data-intelligence/params.mutate-param",
    GAME_CLIENT_PARAMS_VIEW_PARAMS_LIST: "/game/data-intelligence/params.view-params-list",
    LIVE_EVENTS_CREATE_LIVE_EVENT: "/game/live-events.create-live-event",
    LIVE_EVENTS_DESTRUCTIVE_LIVE_EVENT: "/game/live-events.destructive-live-event",
    LIVE_EVENTS_MUTATE_LIVE_EVENT: "/game/live-events.mutate-live-event",
    LIVE_EVENTS_VIEW_LIVE_EVENTS: "/game/live-events.view-live-events",
    EXPERIMENTS_CREATE_EXPERIMENT: "/game/live-services/experiments.create-experiment",
    EXPERIMENTS_MUTATE_EXPERIMENT: "/game/live-services/experiments.mutate-experiment",
    EXPERIMENTS_VIEW_EXPERIMENTS: "/game/live-services/experiments.view-experiments",
    FLYWHEELS_CREATE_FLYWHEEL: "/game/live-services/flywheels.create-flywheel",
    FLYWHEELS_DESTRUCTIVE_FLYWHEEL: "/game/live-services/flywheels.destructive-flywheel",
    FLYWHEELS_MUTATE_FLYWHEEL: "/game/live-services/flywheels.mutate-flywheel",
    FLYWHEELS_VIEW_FLYWHEELS: "/game/live-services/flywheels.view-flywheels",
    UPCOMING_EVENTS_DESTRUCTIVE_UPCOMING_EVENT: "/game/live-services/upcoming.destructive-upcoming-event",
    UPCOMING_EVENTS_PUBLISH_UPCOMING_EVENT: "/game/live-services/upcoming.publish-upcoming-event",
    UPCOMING_EVENTS_SCHEDULE_UPCOMING_EVENT: "/game/live-services/upcoming.schedule-upcoming-event",
    UPCOMING_EVENTS_VIEW_UPCOMING_EVENTS: "/game/live-services/upcoming.view-upcoming-events",
    PLAYER_ATTRIBUTES_CREATE_ATTRIBUTE_CATEGORY: "/game/player-attributes.create-attribute-category",
    PLAYER_ATTRIBUTES_CREATE_PLAYER_ATTRIBUTE: "/game/player-attributes.create-player-attribute",
    PLAYER_ATTRIBUTES_MUTATE_ATTRIBUTE_CATEGORY: "/game/player-attributes.mutate-attribute-category",
    PLAYER_ATTRIBUTES_MUTATE_PLAYER_ATTRIBUTE: "/game/player-attributes.mutate-player-attribute",
    PLAYER_ATTRIBUTES_VIEW_PLAYER_ATTRIBUTES_LIST: "/game/player-attributes.view-player-attributes-list",
    SEGMENTATION_CREATE_SEGMENT: "/game/segments.create-segment",
    SEGMENTATION_MUTATE_SEGMENT: "/game/segments.mutate-segment",
    DATA_CONNECTIONS_CREATE_CONNECTION: "/game/settings/data.create-connection",
    DATA_CONNECTIONS_DESTRUCTIVE_CONNECTION: "/game/settings/data.destructive-connection",
    DATA_CONNECTIONS_MUTATE_CONNECTION: "/game/settings/data.mutate-connection",
    DATA_CONNECTIONS_VIEW_CONNECTIONS_LIST: "/game/settings/data.view-connections-list",
    GAME_SETUP_MUTATE_GAME_SETTINGS: "/game/settings/details.mutate-game-settings",
    GAME_SETUP_VIEW_GAME_SETTINGS: "/game/settings/details.view-game-settings",
    GAME_HISTORY_DESTRUCTIVE_GAME_HISTORY: "/game/settings/history.destructive-game-history",
    GAME_HISTORY_UPLOAD_GAME_HISTORY: "/game/settings/history.upload-game-history",
    GAME_HISTORY_VIEW_GAME_HISTORY: "/game/settings/history.view-game-history",
    GAME_KNOWLEDGE_CREATE_GAME_KNOWLEDGE: "/game/settings/knowledge.create-game-knowledge",
    GAME_KNOWLEDGE_DESTRUCTIVE_GAME_KNOWLEDGE: "/game/settings/knowledge.destructive-game-knowledge",
    GAME_KNOWLEDGE_MUTATE_GAME_KNOWLEDGE: "/game/settings/knowledge.mutate-game-knowledge",
    GAME_KNOWLEDGE_VIEW_GAME_KNOWLEDGE_LIST: "/game/settings/knowledge.view-game-knowledge-list",
    VECTOR_INDEX_VIEW_CHUNK_TEXT: "/game/settings/knowledge/vector-index.view-chunk-text",
    OBJECTIVES_DESTRUCTIVE_OBJECTIVE: "/game/settings/objectives.destructive-objective",
    OBJECTIVES_MUTATE_OBJECTIVES: "/game/settings/objectives.mutate-objectives",
    OBJECTIVES_VIEW_OBJECTIVES: "/game/settings/objectives.view-objectives",
    SDK_INTEGRATION_MANAGE_CREDENTIALS: "/game/settings/sdk.manage-credentials",
    GAME_FEATURES_CREATE_GAME_FEATURE: "/game/settings/systems.create-game-feature",
    GAME_FEATURES_MUTATE_GAME_FEATURE: "/game/settings/systems.mutate-game-feature",
    CLIENT_VERSIONS_CREATE_CLIENT_VERSION: "/game/settings/versions.create-client-version",
    CLIENT_VERSIONS_MUTATE_CLIENT_VERSION: "/game/settings/versions.mutate-client-version",
    PORTFOLIO_DESTRUCTIVE_PORTFOLIO: "/portfolio.destructive-portfolio",
    PORTFOLIO_MUTATE_PORTFOLIO: "/portfolio.mutate-portfolio",
    PORTFOLIO_VIEW_PORTFOLIOS: "/portfolio.view-portfolios",
};

// Game pages whose data follows the header's geography; every other game page is game-wide (rbac-config.json).
export const GEOGRAPHY_PAGES = [
    "/game/ai-recommendations",
    "/game/chat",
    "/game/configs",
    "/game/live-events",
    "/game/live-services/upcoming",
    "/game/segments",
];

export const GAME_WIDE_PAGES = [
    "/game/ai-studio/alerts",
    "/game/ai-studio/query-library",
    "/game/ai-studio/skill-registry",
    "/game/ai-studio/workflow",
    "/game/calendar",
    "/game/dashboard",
    "/game/data-intelligence/event-groups",
    "/game/data-intelligence/events",
    "/game/data-intelligence/metric-catalog",
    "/game/data-intelligence/params",
    "/game/live-services/experiments",
    "/game/live-services/flywheels",
    "/game/player-attributes",
    "/game/settings/data",
    "/game/settings/details",
    "/game/settings/history",
    "/game/settings/knowledge",
    "/game/settings/knowledge/vector-index",
    "/game/settings/objectives",
    "/game/settings/sdk",
    "/game/settings/systems",
    "/game/settings/versions",
];

// Only a game's owners can use these: no role or override grants them (rbac-config.json ownerOnly).
export const OWNER_ONLY_PAGES = [
    "/game/settings/data",
];

// Every owner-only component, the components of OWNER_ONLY_PAGES included.
export const OWNER_ONLY_COMPONENTS = [
    "/admin-settings/game-mgmt/game-access-mgmt.mutate-game-user",
    "/admin-settings/game-mgmt/games.activate-game",
    "/admin-settings/game-mgmt/games.mutate-game",
    "/admin-settings/game-mgmt/games.suspend-game",
    "/game/settings/data.create-connection",
    "/game/settings/data.destructive-connection",
    "/game/settings/data.mutate-connection",
    "/game/settings/data.view-connections-list",
    "/game/settings/sdk.manage-credentials",
];

// Only rbac-config.json's role definitions decide these (configOnly): no override, no role edit.
export const CONFIG_ONLY_PAGES = [
    "/admin-settings/access-mgmt/org",
    "/admin-settings/access-mgmt/org-user",
    "/admin-settings/game-mgmt/game-access-mgmt",
    "/admin-settings/game-mgmt/games",
    "/admin-settings/role-access-mgmt/page",
    "/admin-settings/role-access-mgmt/role",
    "/admin-settings/user-mgmt",
    "/ai-credits",
];

// Every component of CONFIG_ONLY_PAGES.
export const CONFIG_ONLY_COMPONENTS = [
    "/admin-settings/access-mgmt/org.create-organization",
    "/admin-settings/access-mgmt/org.mutate-organization",
    "/admin-settings/access-mgmt/org.view-organizations-list",
    "/admin-settings/game-mgmt/game-access-mgmt.mutate-game-user",
    "/admin-settings/game-mgmt/games.activate-game",
    "/admin-settings/game-mgmt/games.create-game",
    "/admin-settings/game-mgmt/games.mutate-game",
    "/admin-settings/game-mgmt/games.suspend-game",
    "/admin-settings/game-mgmt/games.view-games-list",
    "/admin-settings/role-access-mgmt/page.destructive-page-registry",
    "/admin-settings/role-access-mgmt/page.mutate-page-registry",
    "/admin-settings/role-access-mgmt/page.view-pages-list",
    "/admin-settings/role-access-mgmt/role.assign-page-permissions",
    "/admin-settings/role-access-mgmt/role.create-role",
    "/admin-settings/role-access-mgmt/role.destructive-role",
    "/admin-settings/role-access-mgmt/role.mutate-role",
    "/admin-settings/role-access-mgmt/role.mutate-system-role",
    "/admin-settings/role-access-mgmt/role.view-roles-list",
    "/admin-settings/user-mgmt.invite-user",
    "/admin-settings/user-mgmt.mutate-user-access",
    "/admin-settings/user-mgmt.revoke-user-access",
    "/admin-settings/user-mgmt.view-users-list",
    "/ai-credits.grant-credits",
    "/ai-credits.purchase-credits",
    "/ai-credits.set-allocation-mode",
    "/ai-credits.set-user-limit",
    "/ai-credits.view-all-usage",
    "/ai-credits.view-usage",
];
